import { api, apiFile } from "api/api";
import { AxiosError } from "axios";
import Pessoa from "model/administracao/cadastro/Pessoa";
import Usuario from "model/administracao/cadastro/Usuario";
import HelpdeskChamado from "model/helpdesk/HelpdeskChamado";
import HelpdeskTipoChamado from "model/helpdesk/HelpdeskTipoChamado";
import HelpdeskTramite from "model/helpdesk/HelpdeskTramite";
import Page from "model/page/Page";
import Pageable from "model/page/Pageable";
import { DataTableFilterMeta } from "primereact/datatable";
import { BaseServiceCadastros } from "service/BaseServiceCadastros";
import { getFilters } from "utils/filterUtils";

class HelpdeskChamadoService implements BaseServiceCadastros<HelpdeskChamado> {
    
    pesquisar(page: Pageable,  filters: DataTableFilterMeta) {
        return new Promise<Page>((resolve, reject): void => {
            let url = `/helpdeskChamado/pesquisar`;
            url += getFilters(filters);
            const params = {
                page: page.page,
                size: page.size,
                sort: page.sort,
            };

            api
                .get(url, { params })
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => {reject(err.response);
                    console.error('Error status:', err.response?.status);
                    console.error('Error details:', err.response?.data);
                })
        });
    }

    pesquisarCliente(page: Pageable,  filters: DataTableFilterMeta) {
        return new Promise<Page>((resolve, reject): void => {
            let url = `/helpdeskChamado/pesquisar/cliente`;
            url += getFilters(filters);
            const params = {
                page: page.page,
                size: page.size,
                sort: page.sort,
            };

            api
                .get(url, { params })
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => {reject(err.response);
                    console.error('Error status:', err.response?.status);
                    console.error('Error details:', err.response?.data);
                })
        });
    }

    consultar(id: number) {
        return new Promise<HelpdeskChamado>((resolve, reject): void => {
            api
                .get(`/helpdeskChamado/consultar/${id}`)
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    incluir(helpdeskChamado: HelpdeskChamado) {
        return new Promise<HelpdeskChamado>((resolve, reject): void => {
            api
                .post(`/helpdeskChamado/incluir`, JSON.stringify(helpdeskChamado))
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    editar(helpdeskChamado: HelpdeskChamado) {
        return new Promise<HelpdeskChamado>((resolve, reject): void => {
            api
                .put(`/helpdeskChamado/editar`, JSON.stringify(helpdeskChamado))
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    excluir(id: number) {
        return new Promise<void>((resolve, reject): void => {
            api
                .delete(`/helpdeskChamado/excluir/${id}`)
                .then(() => resolve())
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    finalizar(id: number) {
        return new Promise<void>((resolve, reject): void => {
            api
                .put(`/helpdeskChamado/finalizar/${id}`)
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    gerarPorCliente(helpdeskChamado: HelpdeskChamado) {
        return new Promise<HelpdeskChamado>((resolve, reject): void => {
            api
                .post(`/helpdeskChamado/gerarPorCliente`, JSON.stringify(helpdeskChamado))
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    clientes() {
        return new Promise<Pessoa[]>((resolve, reject): void => {
            api
                .get(`/helpdeskChamado/clientes`)
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    usuarios() {
        return new Promise<Usuario[]>((resolve, reject): void => {
            api
                .get(`/helpdeskChamado/usuarios`)
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    usuariosCliente(id: number) {
        return new Promise<Usuario[]>((resolve, reject): void => {
            api
                .get(`/helpdeskChamado/usuariosCliente/${id}`)
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    tiposChamado() {
        return new Promise<HelpdeskTipoChamado[]>((resolve, reject): void => {
            api
                .get(`/helpdeskChamado/tiposChamado`)
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    getUsuarios() {
        return new Promise<Array<Usuario>>((resolve, reject): void => {
            api
                .get(`/helpdeskChamado/usuarios`)
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    getStatusLista(){
        return [{
                value: "AGUARDANDO_ATENDENTE",
                label: "Aguardando Atendente"
            },
            {
                value: "AGUARDANDO_CLIENTE",
                label: "Aguardando Cliente"
            },
            {
                value: "FINALIZADO",
                label: "Finalizado"
            }]
    }

    getStatus(status: string): string {
        let statusObj = this.getStatusLista().find((item) => item.value === status)
        if (statusObj) {
            return statusObj.label
        }
        return "";
    }

    getListaStatusFilter() {
        return [
            { label: "Aguardando Atendente", value: "AA" },
            { label: "Aguardando Cliente", value: "AC" },
            { label: "Finalizado", value: "F" }
        ]
    }

    getPrioridadeLista(){
        return [{
                value: "BAIXA",
                label: "Baixa"
            },
            {
                value: "MEDIA",
                label: "Média"
            },
            {
                value: "ALTA",
                label: "Alta"
            },
            {
                value: "URGENTE",
                label: "Urgente"
            }]
    }

    getPrioridade(status: string): string {
        let statusObj = this.getPrioridadeLista().find((item) => item.value === status)
        if (statusObj) {
            return statusObj.label
        }
        return "";
    }

    getListaPrioridadeFilter() {
        return [
            { label: "Baixa", value: "B" },
            { label: "Média", value: "M" },
            { label: "Alta", value: "A" },
            { label: "Urgente", value: "U"}
        ]
    }
}

export default HelpdeskChamadoService;